<template>
  <div class="absolute inset-0 z-40 overflow-hidden pointer-events-none">
    <transition-group name="fade" tag="div">
      <div
        v-for="cursor in otherCursors"
        :key="cursor.id"
        :style="getPosition(cursor)"
        class="absolute text-4xl"
      >
        <span v-if="cursor.mouse.flag" v-text="cursor.mouse.flag" />
        <span v-else class="h-6 w-6 bg-red-600 absolute z-40 rounded-full" />
      </div>
    </transition-group>
    <div
      ref="myflag"
      :style="myPos"
      class="hidden md:block fixed text-4xl transition-opacity duration-200"
      :class="{ 'opacity-0': !show }"
    >
      {{ this.flag }}

      <transition name="fade">
        <div
          class="mono text-sm ml-14 -mt-8 hidden md:block drop-shadow-md"
          v-if="showNote"
        >
          Click and drag!
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { io } from 'socket.io-client'
import { throttle } from 'lodash'

export default {
  name: 'Cursors',
  data() {
    return {
      flag: null,
      socket: io(process.env.VUE_APP_SOCKET_SERVER),
      otherCursors: {},
      position: { x: 0, y: 0 },
      showNote: true,
    }
  },
  mounted() {
    let circles = ['🔴', '⚪️', '🟢', '🔵', '🟡', '🟣', '⚫️', '🟠', '🟤']
    this.flag = circles[Math.floor(Math.random() * circles.length)]
    window.addEventListener('mousemove', throttle(this.move, 50))
    window.addEventListener('mousemove', this.moveMy)

    this.socket.on('move', (data) => {
      this.$set(this.otherCursors, data.id, data)
    })

    this.socket.on('disconnected', (data) => {
      this.$delete(this.otherCursors, data)
    })

    window.setTimeout(() => {
      this.showNote = false
    }, 5000)
  },
  computed: {
    myPos() {
      return {
        left: this.position.x - 15 + 'px',
        top: this.position.y - window.pageYOffset - 15 + 'px',
      }
    },
    show() {
      return this.$store.state.showMyCursor
    },
  },
  methods: {
    moveMy(e) {
      this.position = {
        x: e.pageX,
        y: e.pageY,
      }
    },
    move(e) {
      const payload = {
        flag: this.flag,
        x: e.pageX,
        y: e.pageY,
        w: window.innerWidth,
        h: window.innerHeight,
      }

      this.$store.commit('MOVE_CURSOR', payload)

      this.socket.emit('move', payload)
    },

    getPosition(cursor) {
      return {
        left: (window.innerWidth / cursor.mouse.w) * cursor.mouse.x + 'px',
        top: (window.innerHeight / cursor.mouse.h) * cursor.mouse.y + 'px',
      }
    },
  },
}
</script>
